import { html, LitElement, nothing, TemplateResult } from 'lit';
import { NotesListWebComponent } from '../../notesList';
import { SideMenuWidthValues } from '../../../ui/gzSideMenu/types';
import { styles } from '../view/styles';
import { CSSResultGroup } from '@lit/reactive-element/css-tag';

export class NotesPanelWebComponent extends LitElement {
  private dependencies: any;

  public static get styles(): CSSResultGroup {
    return styles;
  }

  public injectDependencies(dependencies: any): void {
    this.dependencies = dependencies;
  }

  protected render(): TemplateResult | typeof nothing {
    if (!this.dependencies) {
      return nothing;
    }

    const notesList = new NotesListWebComponent();

    notesList.injectDependencies(this.dependencies);
    notesList.start();

    return html`
      <div class="wrapper">
        <gz-side-menu menuWidth="${SideMenuWidthValues.MEDIUM}" isOpen>
          ${notesList}
        </gz-side-menu>
      </div>
    `;
  }
}
